import * as Yup from 'yup';
import { minOneWhenTrue } from '../utils';

const followUpContactSchema = Yup.object({
    referralDate: Yup.string().required('error_required_field'),
    referrerTitle: Yup.string().required('error_required_field'),
    referrerName: Yup.string().required('error_required_field'),
    contactInformation: Yup.string().required('error_required_field'),
    description: Yup.string().required('error_required_field'),
});

export const initialValues = {
    wereThereAnyFollowUpSessions: null,
    noOfFollowUps: 0,
    followUpContacts: [],
};

export const validationSchema = Yup.object({
    wereThereAnyFollowUpSessions: Yup.boolean().required('error_required_field'),
    noOfFollowUps: Yup.number().min(0).when('wereThereAnyFollowUpSessions', minOneWhenTrue()),
    followUpContacts: Yup.array().of(followUpContactSchema).when('wereThereAnyFollowUpSessions', minOneWhenTrue()),
});
